import { AudioData } from "../../data/AudioData";
import { FloatArrayAudioData } from "../../data/FloatArrayAudioData";
import { AudioBuilderContext } from "../AudioBuilderContext";
import { ModifiableCurve } from "../curves/ModifiableCurve";
import { Instrument } from "../Instrument";
import { Key } from "../Key";

export abstract class Component
{
  abstract generate( context:AudioBuilderContext ):Promise<AudioData>;
}